import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/others/Badges";
import { Eye, Download, FileText } from "lucide-react";

interface CourseBrochureProps {
  fileName?: string;
  fileSize?: string;
}

export default function CourseBrochure({
  fileName = "Diploma in Web Development",
  fileSize = "0.91 mb",
}: CourseBrochureProps) {
  return (
    <div className="flex flex-col gap-2 py-4 w-full">
      <p className="font-medium text-[#171717] text-[16px] tracking-[-0.32px] leading-normal">
        Course Brochure
      </p>
      <div className="bg-white border border-[rgba(40,12,242,0.06)] flex gap-2 h-[56px] items-center px-4 py-2 rounded-[12px] w-full">
        {/* File Icon */}
        <div className="relative size-8 shrink-0">
          <FileText className="size-8 text-[#cacfd8]" strokeWidth={1.5} />
          <Badge className="absolute bottom-0.5 left-0 bg-[#fb3748] !rounded-[3px] !px-1 !py-0.5 !text-white !text-[9px] !font-medium uppercase !leading-tight tracking-tight !h-auto border-none">
            PDF
          </Badge>
        </div>

        <div className="flex-1 flex flex-col gap-1 justify-center min-w-0">
          <p className="font-medium text-[var(--colorblack-10)] text-[14px] tracking-[-0.42px] leading-normal truncate">
            {fileName}
          </p>
          <p className="font-normal text-[var(--color-black-7)] text-[12px] tracking-[-0.24px] leading-normal">
            {fileSize}
          </p>
        </div>

        <Button variant="outline" size="icon-sm" className="size-9 border-none">
          <Eye
            className="size-6 text-[var(--color-black-8)]"
            strokeWidth={1.5}
          />
        </Button>
        <Button variant="outline" size="icon-sm" className="size-9 border-none">
          <Download
            className="size-4 text-[var(--color-black-8)]"
            strokeWidth={2}
          />
        </Button>
      </div>
    </div>
  );
}
